import videojs from "@/vendor/videojs/video.es.js";
import VirtualDirector from "@/vendor/vd.js";
const Plugin = videojs.getPlugin("plugin");

class HiAutozoom extends Plugin {
  constructor(player, options) {
    super(player, options);
    this.player = player;
    this.timeline = {};

    this.on(player, "setupAutozoom", this.setupAutozoom);
    this.on(player, "destroyAutozoom", this.destroyAutozoom);
  }
  dispose() {
    super.dispose();
  }
  setupAutozoom(e, {timelineData, useOffset}) {
    let that = this;
    let hlsSegmentLength = 8000;
    let offset = 0;

    if (useOffset == true) {
      //"index" in this case is the original index from the full video
      this.player.hiliteSports.vd.offset = this.player.tech().hls.playlists.media().segments[0].index * hlsSegmentLength;
    }

    this.player.hiliteSports.vd.mode = "vd";
    this.player.hiliteSports.videoElWrapper.removeAttribute('style');

    this.player.hiliteSports.vd.stepOnce();

    this.player.hiliteSports.videoEl.onplay = function() {
      that.player.hiliteSports.videoElWrapper.classList.add("animating");
      that.player.hiliteSports.videoElWrapper.classList.remove("animating-paused");
      that.player.hiliteSports.vd.play();
    }

    this.player.hiliteSports.videoEl.onpause = function() {
      that.player.hiliteSports.videoElWrapper.classList.remove("animating");
      that.player.hiliteSports.videoElWrapper.classList.add("animating-paused");
      that.player.hiliteSports.vd.pause();
    }

    this.player.hiliteSports.videoEl.onseeked = function() {
      that.player.hiliteSports.vd.stepOnce();
    }

    if (!this.player.hiliteSports.videoEl.paused) {
      that.player.hiliteSports.videoElWrapper.classList.add("animating");
      that.player.hiliteSports.videoElWrapper.classList.remove("animating-paused");
      that.player.hiliteSports.vd.canPlay = true;
      that.player.hiliteSports.vd.play();
    }

  }
  destroyAutozoom() {
    this.player.hiliteSports.videoEl.onseeked = null;
    this.player.hiliteSports.videoEl.ontimeupdate = null;
    this.player.hiliteSports.videoEl.onplay = null;
    this.player.hiliteSports.videoEl.onpause = null;
    this.player.hiliteSports.vd.isPlaying = false;
    this.player.hiliteSports.videoElWrapper.classList.remove("animating", "animating-paused");
  }
}

videojs.registerPlugin("HiAutozoom", HiAutozoom);
